import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@radix-ui/themes/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Theme } from '@radix-ui/themes';
import "./tw.css";
import './styles/theme.css'; // musí byť až po bootstrape!
import './styles/mobile.css';

function Root() {
    return (
        <Theme appearance="light" accentColor="brown" radius="large">
            <App />
        </Theme>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
